import { RadioGroup } from '@wix/design-system';
import React, { useContext, useState } from 'react';
import { RicosContext } from 'ricos-context';
import { LinkInput } from 'wix-rich-content-ui-components';
import { EDIT_PANEL_RADIO_GROUP, EDIT_PANEL_RADIO_HTML, EDIT_PANEL_RADIO_URL, EDIT_PANEL_URL_INPUT } from '../../dataHooks.js';
import { HtmlInputArea } from './HtmlInputArea.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const INPUT_HTML = "html";
const INPUT_URL = "url";
const HtmlSourceInput = ({
  componentData,
  updateComponentData,
  inputRef
}) => {
  var _a;
  const { t } = useContext(RicosContext);
  const [inputType, setInputType] = useState(componentData.url ? INPUT_URL : INPUT_HTML);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    RadioGroup,
    {
      display: "vertical",
      value: inputType,
      onChange: (value) => setInputType(value),
      dataHook: EDIT_PANEL_RADIO_GROUP,
      size: "small"
    },
    /* @__PURE__ */ React.createElement(RadioGroup.Radio, { value: INPUT_HTML, dataHook: EDIT_PANEL_RADIO_HTML }, t("HtmlEditPanel_Code")),
    /* @__PURE__ */ React.createElement(RadioGroup.Radio, { value: INPUT_URL, dataHook: EDIT_PANEL_RADIO_URL }, t("HtmlEditPanel_Source"))
  ), inputType === INPUT_HTML ? /* @__PURE__ */ React.createElement(
    HtmlInputArea,
    {
      placeholder: t("HtmlEditPanel_HtmlInput_Placeholder"),
      componentData,
      onChange: updateComponentData
    }
  ) : /* @__PURE__ */ React.createElement(
    LinkInput,
    {
      value: (_a = componentData.url) != null ? _a : "",
      placeholder: t("HtmlEditPanel_UrlInput_Placeholder"),
      dataHook: EDIT_PANEL_URL_INPUT,
      inputRef,
      onChange: (url) => {
        updateComponentData(__spreadProps(__spreadValues({}, componentData), { url, html: void 0 }));
      }
    }
  ));
};

export { HtmlSourceInput };
//# sourceMappingURL=HtmlSourceInput.js.map
